import axios from 'axios';
import router from '@/router';

let self = this;

const state = {
  token: localStorage.getItem('access_token') || '',
  status: '',
  initial: {},
  error: {},
};

const getters = {
  status: state => state.status,
  error: state => state.error,
  initial: state => state.initial,
  isAuthenticated: state => !!state.token,
};

const actions = {
  login({ commit, dispatch }, user) {
    return new Promise((resolve, reject) => {
      commit('auth_request');
      delete axios.defaults.headers.common["Authorization"];
      axios({ url: `${process.env.VUE_APP_ROOT_API}/jwt/create/`, data: user, method: 'POST' })
        .then(resp => {
          const user_id = resp.data.user_id;
          const access_token = resp.data.access;
          const refresh_token = resp.data.refresh;       
          localStorage.setItem('user_id', user_id);
          localStorage.setItem('access_token', access_token);
          localStorage.setItem('refresh_token', refresh_token);
          axios.defaults.headers.common['Authorization'] = `JWT ${access_token}`;
          commit('auth_success', access_token);
          dispatch('user/getUser', user_id);
          router.push('/activities');
          resolve(resp);
        })
        .catch(error => {
          const err = error.response.data;
          commit('auth_error', err);
          reject(error);
        });
    })
  },
  logout({ commit, dispatch }) {
    return new Promise((resolve, reject) => {
      commit('auth_logout');
      localStorage.removeItem('user_id');
      localStorage.removeItem('access_token');
      localStorage.removeItem('refresh_token');
      delete axios.defaults.headers.common["Authorization"]; 
      router.push('/');
      resolve();
    })
  },
  refresh({ commit, dispatch }) {
    return new Promise((resolve, reject) => {
      //commit('auth_request');
      const refresh = localStorage.getItem('refresh_token');
      axios({ url: `${process.env.VUE_APP_ROOT_API}/jwt/refresh/`, data: { refresh }, method: 'POST' })
        .then(resp => {
          const access_token = resp.data.access;
          localStorage.setItem('access_token', access_token);
          axios.defaults.headers.common['Authorization'] = `JWT ${access_token}`;
          commit('auth_success', access_token);
         // dispatch(action);
          resolve(resp);
        })
        .catch(error => {

          dispatch('logout');
          reject(error);
        })
    });
  },
  register({commit, dispatch}, user) {
    return new Promise((resolve, reject) => {
      commit('register_success');
      delete axios.defaults.headers.common["Authorization"];
      axios({url: `${process.env.VUE_APP_ROOT_API}/users/`, data: user, method: 'POST'})
      .then(resp => {
        commit('register_success');
        //router.push('/login');
        resolve(resp);
      })
      .catch(error => {
        if (error.resposne){
          const err = error.response.data;
          commit('register_error', err);
        }
        reject(error);
      })
    })
  },
  register_initial({commit, dispatch}) {
    return new Promise((resolve, reject) => {
      delete axios.defaults.headers.common["Authorization"];
      axios({url: `${process.env.VUE_APP_ROOT_API}/users/`})
      .then(resp => {
        const initial = resp.data;
        commit('register_initial', initial);
        resolve(resp);
      })
      .catch(error => {
        reject(error);
      })
    })
  },
  userRecovery({commit, dispatch}, user) {
    return new Promise((resolve, reject) => {
     // commit(RECOVERY_REQUEST);
      axios({url: `${process.env.VUE_APP_ROOT_API}/users/password/reset/`, data: user, method: 'POST'})
      .then(resp => {
        //commit(RECOVERY_SUCCESS, resp);
        // router.push('/login');
        resolve(resp);
      })
      .catch(error => {
        const err = error.response.data;
        commit('userRecoveryError', err);
        reject(error);
      })
    })
  },
  userRecoveryConfirm({commit, dispatch}, user) {
    return new Promise((resolve, reject) => {
      axios({url: `${process.env.VUE_APP_ROOT_API}/users/password/reset/confirm/${user.uid}/${user.token}/`, data: user, method: 'POST'})
      .then(resp => {
        // router.push('/login');
        resolve(resp);
      })
      .catch(error => {
        const err = error.response.data;
        commit('userRecoveryError', err);
        reject(error);
      })
    })
  },
  clearErrors({commit, dispatch}) {
    commit('clearErrors');
  },
};

const mutations = {
  auth_request(state) {
    state.status = 'loading';
    state.error = {};
  },
  auth_success(state, access_token) {
    state.status = 'success';
    state.error = {};
    state.token = access_token;
  },
  auth_error(state, error) {
    state.status = 'error';
    state.error = error;
  },
  auth_logout(state) {
    state.token = '';

  },
  register_request(state) {
    state.status = 'loading';
    state.error = {};
  },
  register_success(state) {
    state.status = 'success';
    state.error = {};
  },
  register_initial(state, initial) {
    state.initial = initial;
  },
  register_error(state, error) {
    state.status = 'error';
    state.error = error;
  },
  userRecoveryError(state, error) {
    state.status = 'error';
    state.error = error;
  },
  clearErrors(state) {
    state.status = '';
    state.error = {};
  },
};
const namespaced = true;
export default {
  namespaced,
  state,
  getters,
  actions,
  mutations,
}
